<template>
  <nav class="nv-d-flex nv-align-items-center nv-px-2 desktop-menu">
    <ul class="nv-d-lg-flex nv-flex-nowrap nv-align-items-center menu-items nv-d-none">
      <li
        v-for="(item, idx) in (sectionMenuItems || menuItems)"
        :key="idx"
        class="nv-d-flex nv-align-items-center"
        :class="{'active': isAMnActive(item) }"
        @click="() => setItemSelected(item.id)"
      >
        <a
          v-if="item.url && item.external"
          :href="item.url"
        >
          {{ item.title }}
        </a>
        <nuxt-link
          v-else-if="item.url && !item.external"
          :to="localePath(item.url!)"
          @click="closeMenu"
        >
          {{ item.title }}
        </nuxt-link>
        <span
          v-else
          @click="() => goToAnchor(item.anchor)"
        >
          {{ item.title }}
        </span>
        <div v-if="!item.url && !item.anchor" class="nv-ml-1">
          <nv-icon>
            expand-more
          </nv-icon>
        </div>
      </li>
    </ul>

    <!-- Mobile menu button -->

    <portal to="menu-mobile-btn">
      <ul class="menu-mobile-icon nv-d-flex-none nv-d-lg-none">
        <li class="nv-d-flex nv-align-items-center" @click="openMenu">
          <nv-icon>global-navigation</nv-icon>
        </li>
      </ul>
    </portal>

    <portal to="menu-bg">
      <div
        id="menu-bg-mask"
        :class="{'active': menuOpened}"
        @click="() => closeMenu()"
      />
    </portal>

    <portal to="menu-items-container">
      <!-- Menu content -->
      <div id="menu-content" :class="{'active': menuOpened}" class="nv-grid">
        <!-- Desktop versiom -->
        <div
          v-for="(subMenu, sdix) in subMenuItens"
          :id="subMenu.id"
          :key="sdix"
          class="nv-d-none nv-grid-row"
          :class="{'nv-d-lg-flex': itemSelected === subMenu.id}"
        >
          <div class="nv-grid-col">
            <ul class="w-full flex gap-8">
              <li
                v-for="(item, idx) in subMenu.items"
                :key="idx"
                class="nv-d-flex nv-flex-column"
              >
                <h6>
                  {{ item.title }}
                </h6>
                <!-- Navigation sub items -->
                <div class="nv-my-2">
                  <li
                    v-for="(subItem, sIdx) in item.items"
                    :key="sIdx"
                    class="nv-d-flex nv-align-items-start nv-flex-column nv-mb-1"
                  >
                    <div
                      v-if="subItem.title"
                      class="nv-d-flex nv-w-100 nv-mb-2"
                    >
                      <strong>
                        {{ subItem.title }}
                      </strong>
                    </div>

                    <ul class="nv-d-flex nv-flex-column">
                      <li
                        v-for="(route, rIdx) in subItem.routes"
                        :key="rIdx"
                        class="nv-d-flex nv-align-items-start nv-mb-1"
                      >
                        <nuxt-link :to="localePath(route.path)" @click.native="closeMenu">
                          {{ route.title }}
                        </nuxt-link>
                      </li>
                    </ul>
                  </li>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- Mobile version -->
          <div class="nv-d-block nv-d-lg-none">
            <div class="nv-d-flex nv-justify-content-between nv-mb-3 nv-px-5">
              <div>
                <nv-button
                  v-if="(itemSelected !== 'main-menu') && menuOpened"
                  class="back-mn-mb"
                  text
                  circle
                  @click="() => setTab('main-menu')"
                >
                  <nv-icon>left</nv-icon>
                </nv-button>
              </div>

              <nv-button
                text
                class="close-mb-mb"
                circle
                @click="() => closeMenu()"
              >
                <nv-icon>close</nv-icon>
              </nv-button>
            </div>

            <div class="mn-mb-content nv-px-5">
              <nv-tabs
                id="tab-mobile-menu"
                ref="mobileMenu"
                class="nv-d-block nv-d-lg-none"
              >
                <!-- Main menu -->
                <nv-tab tab="main-menu">
                  <nv-list>
                    <nv-list-item
                      v-for="(item, idx) in menuItems"
                      :key="idx"
                      @click="() => setTab(item.id)"
                    >
                      <span slot="header">
                        {{ item.title }}
                      </span>
                      <nv-icon slot="end">
                        right
                      </nv-icon>
                    </nv-list-item>
                  </nv-list>
                </nv-tab>

                <!-- Submenu items -->
                <nv-tab
                  v-for="(subMenu, sdix) in subMenuItens"
                  :id="subMenu.id"
                  :key="sdix"
                  :tab="subMenu.id"
                >
                  <h4 class="nv-mb-5">
                    {{ (menuItems.find(({ id }) => id === subMenu.id) || {}).title }}
                  </h4>
                  <nv-collapse>
                    <nv-collapse-item
                      v-for="(item, idx) in subMenu.items"
                      :key="idx"
                    >
                      <div
                        slot="header"
                        class="nv-d-flex nv-align-items-center nv-justify-content-between"
                      >
                        <span class="nv-d-flex">
                          {{ item.title }}
                        </span>
                        <div v-if="item.items.length > 0">
                          <nv-icon>expand-more</nv-icon>
                        </div>
                      </div>

                      <div slot="content">
                        <!-- Subitens section -->
                        <div
                          v-for="(subItem, sIdx) in item.items"
                          :key="sIdx"
                          class="nv-d-flex nv-flex-column nv-my-2"
                        >
                          <!-- Title -->
                          <div
                            v-if="subItem.title"
                            class="nv-d-flex nv-w-100 nv-mb-2"
                          >
                            <strong>
                              {{ subItem.title }}
                            </strong>
                          </div>

                          <!-- Items -->
                          <ul class="nv-d-flex nv-flex-column">
                            <li
                              v-for="(route, rIdx) in subItem.routes"
                              :key="rIdx"
                              class="nv-d-flex nv-py-1"
                              @click="closeMenu"
                            >
                              <nuxt-link :to="localePath(route.path)">
                                {{ route.title }}
                              </nuxt-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </nv-collapse-item>
                  </nv-collapse>
                </nv-tab>
              </nv-tabs>
            </div>
          </div>
      </div>
    </portal>
  </nav>
</template>

<script lang="ts" setup>
import type { IMenuSubItems, IRoutesLinksResponse } from '@/utils/types';
// ---------------------------------------------
// Hooks
// ---------------------------------------------

const route = useRoute();
const localePath = useLocalePath();


// ---------------------------------------------
// Props
// ---------------------------------------------

defineProps({
  menuItems: { type: Array as PropType<IRoutesLinksResponse[]>, required: true },
  sectionMenuItems: {
    type: Array as PropType<IRoutesLinksResponse[]>, required: false, default: undefined,
  },
  subMenuItens: { type: Array as PropType<IMenuSubItems[]>, required: true },
})

// ---------------------------------------------
// State
// ---------------------------------------------
const itemSelected = ref('');
const menuOpened = ref(false);
const mobileMenu = useState<HTMLNvTabsElement | undefined>(undefined);

// ---------------------------------------------
// Methods
// ---------------------------------------------

function setItemSelected(id?: string) {
  if (!id) return;

  if (menuOpened.value && itemSelected.value === id) {
    menuOpened.value = false;
    itemSelected.value = '';
    return;
  }

  itemSelected.value = id;
  menuOpened.value = true;
}

function openMenu() {
  setItemSelected('main-menu');
  document.querySelector('html')?.classList.add('mn-mb-opened');
  menuOpened.value = true;
}

function closeMenu() {
  document.querySelector('html')?.classList.remove('mn-mb-opened');
  menuOpened.value = false;
  itemSelected.value = '';
  mobileMenu.value?.select('main-menu');
}

function setTab(tab?: string) {
  if (!tab) return;

  if (!mobileMenu.value) mobileMenu.value = document.querySelector('#tab-mobile-menu') as HTMLNvTabsElement;
  itemSelected.value = tab;
  mobileMenu.value?.select(tab);
}

function goToAnchor(anchor?: string) {
  if (!anchor) return;

  const el = document.querySelector(anchor) as any;
  el?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}

function isAMnActive(item: IRoutesLinksResponse) {
  // Group option
  if (!item.url) {
    return (itemSelected.value === item.id) && menuOpened && !item.url;
  }

  return (item?.url && route.path.endsWith(item.url));
}

// ---------------------------------------------
// Lifecycles
// ---------------------------------------------

onMounted(() => {
  const headerLogo = document.querySelector('#header-logo') as HTMLLinkElement;
  if (headerLogo) {
    headerLogo.addEventListener('click', closeMenu);
  }
});
</script>
<style lang="scss">
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/_mixins';

.desktop-menu {
  ul {
    list-style: none;

    li {
      cursor: pointer;
      height: 62px;
      padding: 8px;
      position: relative;

      &::after {
        @extend .transition-exit;
        background-color: var(--nv-theme-primary);
        bottom: 0;
        content: '';
        height: 2px;
        left: 50%;
        opacity: 0;
        position: absolute;
        transform: translateX(-50%);
        transform-origin: center;
        transition-property: width;
        width: 0%;
      }

      &:hover::after {
        @extend .transition-entrance;
        opacity: 1;
        width: 100%;
      }

      &:not(:last-child) {
        margin-right: 8px;
      }

      a::after {
        display: none;
      }
    }

    a {
      color: var(--nv-color-primary);
    }
  }
}

/*
------------------------------------
Menu mask
------------------------------------
*/

#menu-bg-mask {
  @extend .transition-exit;

  background-color: var(--nv-theme-alt-2);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  visibility: hidden;
  width: 100%;
  z-index: 19;

  &.active {
    @extend .transition-entrance;
    opacity: 0.9;
    visibility: visible;
  }
}

.menu-items .active::after {
  opacity: 1;
  width: 100%;
}

#menu-content {
  @extend .transition-exit;
  color: var(--nv-type-primary);
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: translateY(-80px);
  transition-delay: 0s 2s 2s;
  transition-property: transform opacity visibility;
  visibility: hidden;
  width: 100%;
  z-index: 20;

  * {
    color: var(--nv-type-primary);
  }

  &.active {
    @extend .transition-entrance;
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0s 0s 0s;
    transition-property: transform opacity visibility;
    visibility: visible;
  }

  > div {
    background-color: var(--nv-theme);
    display: none;
    min-height: 150px;
    padding: 140px 80px 40px;
    pointer-events: all;

    li {
      min-width: 250px;
    }
  }

  a {
    color: var(--nv-typo-primary);
  }
}

@include md {
  #menu-content > div {
    padding: 140px 80px 40px;
  }
}

/*
* ------------------------------------------
* Mobile
* ------------------------------------------
*/

.back-mn-mb {
  margin-left: -18px;
}

.close-mb-mb {
  margin-right: -8px;
}

.menu-mobile-icon {
  cursor: pointer;

  nv-icon {
    color: var(--nv-type-secondary);
  }
}

.mn-mb-content {
  display: block;
  height: calc(100% - 60px);
  overflow-y: auto;
}

@media screen and (max-width: 1023px) {
  #menu-content {
    left: unset;
    position: fixed;
    right: 0;
    transform: translateX(80px);
    z-index: 108;

    &.active {
      transform: translateX(16px);
    }
  }

  #menu-bg-mask {
    z-index: 106;
  }

  #menu-content {
    left: unset;
    max-width: 480px;
    right: 0;

    > div {
      height: 100%;
      padding: 40px 0;
    }
  }
}
</style>
